// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-module--wrapper--6d124","main":"layout-module--main--e4575"};